export const environment = {
  production: true,
  //Prod
  urlApiManagement: 'https://prd-ms-mgmt-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlProfileManagement: 'https://prd-ms-profile-mgmt-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlStp: 'https://prd-ms-stp-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlTaskManagement: 'https://prd-ms-task-management-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlQueueManager: 'https://prd-ms-queue-manager.azurewebsites.net',
  urlVendorManagement: 'https://prd-ms-vendor-mgmt-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlSuperClients: 'https://prd-ms-super-clients-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlProjectManagement: 'https://prd-ms-project-mgmt-container.calmsand-28b35018.eastus2.azurecontainerapps.io',
  urlJiraProject: 'https://prd-ms-jira-project.azurewebsites.net',
  redirectUri: 'https://prd-am-operationmgt.nttltd.global.ntt/home',
  clarityKey: 'o5seldwlzv',
  urlMegaboard: '',
  megaboardEnabled: false
};
